var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChargerColor = function SvgChargerColor(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5389_8247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3984 3.23333L11.5 9.09167H14.039C14.4453 9.09167 14.6562 9.61667 14.3828 9.93333L7.81247 17.35C7.48435 17.7167 6.91403 17.35 7.0781 16.8667L8.64841 12.1917H5.96872C5.67185 12.1917 5.4531 11.9 5.5156 11.5917L7.25778 2.89167C7.30466 2.65833 7.49216 2.5 7.71091 2.5H13.9765C14.3281 2.5 14.5547 2.9 14.3906 3.23333H14.3984Z",
    fill: "#007AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5389_8247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 15,
    fill: "white",
    transform: "translate(5.5 2.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChargerColor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "charger-color.3ac0d3f6d41f5432e1557f8a76c0c772.svg";